import { LONG_TERM_QUANTITY, PNL_REPORT_DATA, PNL_SEARCH, PNL_SUMMARIZE, STOCK_INDEX, } from "@frameworks/web/redux/interfaces/Reports/CoreReports/iProfitAndLoss";
import { combineReducers } from "redux";
import commonOnePlatFormReducer from "@frameworks/web/redux/reducers/common/commonReducer";
const initState = {
    pnlData: {
        pnLSummary: {
            totalPnl: "0",
            totalPnlChangePercent: "0",
            realisedPnl: "0",
            realisedPnlChangePercent: "0",
            unrealisedPnl: "0",
            unrealisedPnlChangePercent: "0",
            closePriceDate: "",
            totalMarketValue: "",
            totalClosingCostValue: "",
            totalSellCostValue: "",
            editableCount: 0,
            totalInvestment: "0",
            totalSellValue: "0",
            daysPnLChange: "0",
        },
        pnLDetails: [],
        pnlDataFlags: {
            bodProcessInfoMessage: "",
            isBodEnabled: false
        }
    },
    pnlSummarize: false,
    search: "",
    longTermQuantity: false,
    selectedStockIndex: undefined,
};
const ProfitAndLossReducer = (state = initState, action) => {
    switch (action.type) {
        case PNL_REPORT_DATA:
            return Object.assign(Object.assign({}, state), { pnlData: action.payload.pnlData });
        case PNL_SUMMARIZE:
            const newSummarizeState = Object.assign(Object.assign({}, state), { pnlSummarize: action.payload.pnlSummarize });
            return newSummarizeState;
        case LONG_TERM_QUANTITY:
            const newState = Object.assign(Object.assign({}, state), { longTermQuantity: action.payload.longTermQuantity });
            return newState;
        case PNL_SEARCH:
            return Object.assign(Object.assign({}, state), { search: action.payload.search });
        case STOCK_INDEX:
            return Object.assign(Object.assign({}, state), { selectedStockIndex: action.payload.selectedStockIndex });
        default:
            return state;
    }
};
export default combineReducers({
    reducersData: ProfitAndLossReducer,
    commonData: commonOnePlatFormReducer,
});
